/*** ORIGINAL IMPLEMENTATION: https://gist.github.com/nrobinaubertin/61ff1c3db355c74f4e56f485b566ab22 ***/
import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

function padNumber(value: number) {
    if (isNumber(value)) {
        return `0${value}`.slice(-2);
    } else {
        return "";
    }
}

function isNumber(value: any): boolean {
    return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
    return parseInt(`${value}`, 10);
}


@Injectable()
export class NgbDateFRParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct {
        if (value) {
            const dateParts = value.trim().split('-');
            if (dateParts.length === 1 && isNumber(dateParts[0])) {
                return { year: toInteger(dateParts[0]), month: null, day: null };
            } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
                return { year: toInteger(dateParts[1]), month: toInteger(dateParts[0]), day: null };
            } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
                return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: toInteger(dateParts[2]) };
            }
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        let stringDate: string = "";
        if (date) {
            stringDate += isNumber(date.year) ? date.year + "-" : "";
            stringDate += isNumber(date.month) ? padNumber(date.month) + "-" : "";
            stringDate += isNumber(date.day) ? padNumber(date.day) : "";
        }
        return stringDate;
    }

    toDateString(inputdate: Date): string {
        if (inputdate === null)
            return "";
        let date = new Date(inputdate);
        return date.toISOString().substring(0, 10);
    }

    parseToDateNow(): NgbDateStruct {
        let defaultDate = new Date(Date.now());
        let date = defaultDate.toISOString();
        const dateParts = date.trim().split('-');
        if (dateParts.length === 1 && isNumber(dateParts[0])) {
            return { year: toInteger(dateParts[0]), month: null, day: null };
        } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
            return { year: toInteger(dateParts[1]), month: toInteger(dateParts[0]), day: null };
        } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
            return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: toInteger(dateParts[2]) };
        }

        return null;
    }

    toDateStringYYYYMMDDHHMI(InputDate: Date): string {
        if (InputDate) {
            let date = new Date(InputDate);
            return date.toISOString().substring(0, 10) + " " + date.toTimeString().substring(0, 5);
        }
        return null;
    }

     padNumber(value: number) {
        if (isNumber(value)) {
            return `0${value}`.slice(-2);
        } else {
            return "";
        }
    }
    
    setDefaultEndDates(): NgbDateStruct {
        let date: NgbDateStruct = this.parse("2100-12-31");
        return date;
    }    

    setDefaultEndDatesUpdated(): NgbDateStruct {
        let date: NgbDateStruct = this.parse("2025-12-31");
        return date;
    } 
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/shared/ngb-date-fr-parser-formatter.ts